import {
  CANCEL_SCHEDULE,
  CANCEL_SUBSCRIPTION,
  CHECK_PLAN_LIMIT,
  CLEAR_COUPON_CODE_STATUS,
  DOWNGRADE_PLAN,
  GET_ESTIMATION_DETAILS,
  GET_PLANS_LIST,
  RESET_RESPONSE_STATUS,
  SET_CANCEL_SCHEDULE,
  SET_CANCEL_SUBSCRIPTION,
  SET_DOWNGRADE_PLAN,
  SET_ESTIMATION_DETAILS,
  SET_PLAN_LIMIT,
  SET_PLANS_LIST,
  SET_SHOW_ESTIMATION_SCREEN,
  SET_UPGRADE_PLAN,
  UPGRADE_PLAN
} from "./actionTypes"

export const getPlansList = (payload) => {
  return {
    type: GET_PLANS_LIST,
    payload: payload,
  }
}
export const setPlansList = (payload) => {
  return {
    type: SET_PLANS_LIST,
    payload: payload,
  }
}
export const setShowEstimationScreen = (payload) => {
  return {
    type: SET_SHOW_ESTIMATION_SCREEN,
    payload: payload,
  }
}
export const cancelSubscription = (payload) => {
  return {
    type: CANCEL_SUBSCRIPTION,
    payload: payload,
  }
}
export const setCancelSubscription = (payload) => {
  return {
    type: SET_CANCEL_SUBSCRIPTION,
    payload: payload,
  }
}
export const getEstimationDetails = (payload) => {
  return {
    type: GET_ESTIMATION_DETAILS,
    payload: payload,
  }
}
export const setEstimationDetails = (payload) => {
  return {
    type: SET_ESTIMATION_DETAILS,
    payload: payload,
  }
}
export const upgradePlan = (payload) => {
  return {
    type: UPGRADE_PLAN,
    payload: payload,
  }
}
export const setUpgradePlan = (payload) => {
  return {
    type: SET_UPGRADE_PLAN,
    payload: payload,
  }
}
export const downgradePlan = (payload) => {
  return {
    type: DOWNGRADE_PLAN,
    payload: payload,
  }
}
export const setDowngradePlan = (payload) => {
  return {
    type: SET_DOWNGRADE_PLAN,
    payload: payload,
  }
}
export const checkPlanLimit = (payload) => {
  return {
    type: CHECK_PLAN_LIMIT,
    payload: payload,
  }
}
export const setPlanLimit = (payload) => {
  return {
    type: SET_PLAN_LIMIT,
    payload: payload,
  }
}
export const resetResponseStatus = (payload) => {
  return {
    type: RESET_RESPONSE_STATUS,
    payload: payload,
  }
}
export const clearCouponCodeStatus = (payload) => {
  return {
    type: CLEAR_COUPON_CODE_STATUS,
    payload: payload,
  }
}
export const cancelSchedule = (payload) => {
  return {
    type: CANCEL_SCHEDULE,
    payload: payload,
  }
}
export const setCancelSchedule = (payload) => {
  return {
    type: SET_CANCEL_SCHEDULE,
    payload: payload,
  }
}


